import { create } from 'zustand';

export type EmbeddedState = {
  active: boolean;
  src?: string;
  open: (src?: string) => void | Promise<void>;
  close: () => void;
  onClose?: () => void;
};

export const createEmbeddedStore = () =>
  create<EmbeddedState>((set) => ({
    active: false,
    node: undefined,
    open: (src?) =>
      new Promise<void>((resolve) => {
        // NOTE: requestAnimationFrame is used because of Dropdown onClose event on EmbeddedViewer
        window.requestAnimationFrame(() => {
          set((state) => ({
            ...state,
            active: true,
            src,
            onClose: resolve,
          }));
        });
      }),

    close: () => {
      set((state) => {
        state.onClose?.();
        return {
          ...state,
          active: false,
          src: undefined,
          onClose: undefined,
        };
      });
    },
  }));

export const useEmbeddedViewer = createEmbeddedStore();
